import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/drip-calculator',
  component: () => import('../../routes/DripCalculator.svelte'),
  card: {
    id: 'drip-calculator',
    title: 'Dividend Reinvestment',
    description: 'See how reinvesting dividends accelerates portfolio growth over time.',
    icon: 'monetization_on',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/drip-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'DRIP Calculator – Dividend Reinvestment Calculator',
    description: 'Free DRIP calculator to see how reinvesting dividends accelerates portfolio growth. Compare dividend reinvestment vs taking cash with year-by-year projections, dividend growth, and share price appreciation.',
  },
};

export default meta;
